import { z } from "zod";

export const portfolioHistoryResponseSchema = z.object({
  timestamp: z.array(z.number()),
  equity: z.array(z.number()),
  lmv: z.array(z.number()).nullish(),
  smv: z.array(z.number()).nullish(),
  profit_loss: z.array(z.number()),
  profit_loss_pct: z.array(z.number()),
  base_value: z.number(),
  timeframe: z.string(),
});

// Deprecated: Remove when internal API is updated return type
export const deprecatedPortfolioHistoryResponseSchema = z.object({
  arrays: z
    .tuple([
      z.array(z.number()),
      z.array(z.number()),
      z.array(z.number()),
      z.array(z.number()),
    ])
    .nullish(),
  attributes: z
    .array(z.object({ name: z.string(), type: z.string() }))
    .nullish(),
  base_value: z.number(),
  base_value_asof: z.string().nullish(),
  timeframe: z.string(),
});

export const portfolioHistoryUnionSchema = z.union([
  portfolioHistoryResponseSchema,
  deprecatedPortfolioHistoryResponseSchema,
]);
